import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSelectModule } from '@angular/material/select';
import { FuseHighlightModule } from '@fuse/components/highlight';
import { FuseAlertModule } from '@fuse/components/alert';
import { FuseNavigationModule } from '@fuse/components/navigation';
import { FuseScrollResetModule } from '@fuse/directives/scroll-reset';
import { SharedModule } from 'app/shared/shared.module';

// import { OverviewComponent } from 'app/modules/gen/setup/common/overview_deleted/overview.component';

// import { MessagesComponent } from 'app/modules/gen/setup/common/messages/messages.component';
// import { NotificationsComponent } from 'app/modules/gen/setup/common/notifications/notifications.component';
// import { SearchComponent } from 'app/modules/gen/setup/common/search/search.component';
// import { ShortcutsComponent } from 'app/modules/gen/setup/common/shortcuts/shortcuts.component';
// import { UserComponent } from 'app/modules/gen/setup/common/user/user.component';

// import { setupRoutes } from 'app/modules/gen/setup/setup.routing';
import { SetupHeaderComponent } from './setup-header/setup-header.component';
import { MasterFooterComponent } from 'app/modules/gen/setup/common/master-footer/master-footer.component';
import {MatDialogModule} from '@angular/material/dialog';
import { MasterHistoryComponent } from './master-history/master-history.component';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { LoadingModule } from 'app/shared/loading/loading/loading.module';


@NgModule({
    declarations: [

        // OverviewComponent,
        MasterFooterComponent,
        // MessagesComponent,
        // NotificationsComponent,
        // SearchComponent,
        // ShortcutsComponent,
        // UserComponent,
        SetupHeaderComponent,
        MasterHistoryComponent
    ],
    imports: [
        // RouterModule.forChild(setupRoutes),
        MatButtonModule,
        MatIconModule,
        MatFormFieldModule,
        MatTableModule,
        LoadingModule,
        MatPaginatorModule,
        MatInputModule,
        MatRadioModule,
        MatSelectModule,
        MatSidenavModule,
        FuseHighlightModule,
        FuseAlertModule,
        FuseNavigationModule,
        FuseScrollResetModule,
        SharedModule,MatDialogModule
    ],
    exports: [
        SetupHeaderComponent,
        MasterFooterComponent,
        MasterHistoryComponent
    ]
})
export class SetupCommonModule {
}
